import React from 'react';

import './ManageBonus.css';
import { BONUS_PAGES } from './constants';

import ErrorFeedbackBar from '../../global/ErrorFeedbackBar';
import FeedbackBar from '../../feedbackBar/FeedbackBar';
import withShipment from '../../../withShipment';
import { statusSelector } from '../../../redux/selectors/global';
import { clearStatus } from '../../../redux/actions/global';
import { userInfoSelector, viewOnlySelector } from '../../../redux/selectors/auth';
import {
  deleteManageBonus,
  listManageBonus,
  saveManageBonus,
  toggleManageBonus,
} from '../../../redux/actions/settings';
import { manageBonusSelector } from '../../../redux/selectors/settings';

import BonusList from './BonusList';
import EditBonus from './EditBonus';
import { downloadBonusSchedulePdf } from './bonusPdf';

class ManageBonus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: BONUS_PAGES.TABLE,
      editBonus: null,
      readOnly: false,
      feedbackBarOpen: false,
      feedbackStatus: '',
      feedbackMessage: '',
    };
  }

  componentDidMount() {
    this.props.listManageBonus({ locationId: this.props.user.selectedLocationId });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.status.statusText &&
      prevProps.status.statusText !== this.props.status.statusText
    ) {
      this.openFeedbackBar('error', this.props.status.statusText);
    }
  }

  openFeedbackBar = (status, message) =>
    this.setState({ feedbackStatus: status, feedbackMessage: message, feedbackBarOpen: true });

  closeFeedbackBar = () =>
    this.setState(
      { feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' },
      () => this.props.clearStatus()
    );

  // EditBonus has a purpose-built readOnly mode — it retitles the page
  // "View bonus" and inerts every field. A VIEW-ONLY location is the only
  // thing that drives it: everyone who can reach this screen holds the
  // manage-bonus permission, so authorship never restricts editing.
  // See constants/readOnlyAccess.js.
  handleOpen = (bonus) =>
    this.setState({
      editBonus: bonus,
      readOnly: this.props.viewOnly,
      currentPage: BONUS_PAGES.FORM,
    });

  handleNew = () => {
    // The Add Bonus toolbar item is already dropped for a viewer; this is
    // the belt to that braces, in case a future entry point calls it.
    if (this.props.viewOnly) return;
    this.setState({ editBonus: null, readOnly: false, currentPage: BONUS_PAGES.FORM });
  };

  handleEditingClear = () =>
    this.setState({ editBonus: null, readOnly: false, currentPage: BONUS_PAGES.TABLE });

  handleToggle = (bonus, nextActive) =>
    this.props.viewOnly
      ? undefined
      : this.props.toggleManageBonus(
      { manageBonusId: bonus.manageBonusId, enabled: nextActive },
      (err, message) => {
        if (err) this.openFeedbackBar('error', message || 'Could not update bonus');
      }
    );

  // The Delete button is already hidden in EditBonus's readOnly mode; this
  // is the belt to that braces, matching handleNew / handleToggle. Delete is
  // NOT creator-gated — any manage-bonus holder may remove any bonus.
  handleDelete = (manageBonusId) => {
    if (this.props.viewOnly) return;
    this.props.deleteManageBonus({ manageBonusId });
  };

  handleDownloadPdf = () => {
    const bonuses = this.props.bonus || [];
    if (bonuses.length === 0) {
      this.openFeedbackBar('error', 'No bonuses to export');
      return;
    }
    downloadBonusSchedulePdf(
      bonuses,
      this.props.user.selectedLocationName || 'Location'
    );
  };

  render() {
    const { currentPage, editBonus, readOnly } = this.state;
    return (
      <React.Fragment>
        <ErrorFeedbackBar />
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        {currentPage === BONUS_PAGES.FORM ? (
          <EditBonus
            user={this.props.user}
            editBonus={editBonus}
            readOnly={readOnly}
            saveBonus={this.props.saveManageBonus}
            handleDelete={this.handleDelete}
            handleEditingClear={this.handleEditingClear}
            openFeedbackBar={this.openFeedbackBar}
          />
        ) : (
          <BonusList
            bonuses={this.props.bonus}
            onOpen={this.handleOpen}
            onNew={this.handleNew}
            onToggle={this.handleToggle}
            onDownloadPdf={this.handleDownloadPdf}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  status: statusSelector(state),
  user: userInfoSelector(state),
  viewOnly: viewOnlySelector(state),
  bonus: manageBonusSelector(state),
});

const actionCreators = {
  clearStatus,
  saveManageBonus,
  listManageBonus,
  deleteManageBonus,
  toggleManageBonus,
};

export default withShipment({ actionCreators, mapStateToProps }, ManageBonus);
